import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCqeVXljLluZpsRoJTibbVGkZeJDhVddgg",
  authDomain: "apppsalms-f6dee.firebaseapp.com",
  databaseURL: "https://apppsalms-f6dee-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "apppsalms-f6dee",
  storageBucket: "apppsalms-f6dee.firebasestorage.app",
  messagingSenderId: "183986708552",
  appId: "1:183986708552:web:6f8c3699088d4cdace787d",
  measurementId: "G-FSKHPZTH6Q"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: "select_account" });
export const db = getDatabase(app);
